import { ClassicChat } from '@vp/care-classic-chat';
import {
    Banner,
    BannerDescription,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Button,
    FluidImage,
    Icon,
    Link,
    P,
} from '@vp/swan';
import { isChatAnywhereEnabled } from '@99designs/care';
import { __, __image, __url } from '@99designs/i18n';
import { sendChatNowTrackingEvent, sendNavigationEvent, usePage } from '@99designs/tracking';
import { CloudinaryImage } from '../CloudinaryImage';

const supportAnalyticsData = {
    label: 'Content:Help Center Section',
    eventDetail: '/design;/graphic-design;Help Center Section;VisitHelpCenter-CTA',
    navigationDetail: 'VisitHelpCenter-CTA',
    category: 'Navigation Clicked',
};

export function SupportBanner({ locale }: { locale: string }) {
    const { pageData } = usePage();

    return (
        <>
            <Banner data-testid="support-banner" variant="card" backgroundColor="warm-white">
                <BannerTextContainer>
                    <BannerText>
                        <BannerTitle>{__('Help, any time')}</BannerTitle>
                        <BannerDescription>
                            <P>
                                {__(
                                    'Browse our Help Centre or chat with one of our Customer Care Specialists who will be available anytime to help you get a great design.'
                                )}
                            </P>
                        </BannerDescription>
                        <BannerLinks>
                            <Button
                                id="onlineBtn"
                                skin="secondary"
                                onClick={() =>
                                    sendNavigationEvent({
                                        ...supportAnalyticsData,
                                        ...pageData,
                                    })
                                }
                                iconPosition="left"
                                data-section={supportAnalyticsData.label}
                                data-position={0}
                                data-translation={supportAnalyticsData.navigationDetail}
                                render={(props) => (
                                    <Link
                                        to={__url('/customer-care/help-center/')}
                                        className={props.className}
                                    >
                                        {props.children}
                                    </Link>
                                )}
                            >
                                <Icon iconType="helpQuery" />
                                {__('Visit help center')}
                            </Button>
                            <Button
                                id="onlineBtn"
                                skin="secondary"
                                iconPosition="left"
                                onClick={() => sendChatNowTrackingEvent({ locale, ...pageData })}
                            >
                                <Icon iconType="liveChat" />
                                {__('Chat with us')}
                            </Button>
                        </BannerLinks>
                    </BannerText>
                </BannerTextContainer>
                <BannerImageContainer>
                    <BannerImage>
                        <CloudinaryImage
                            render={(props) => (
                                <FluidImage
                                    src={props.src}
                                    srcSet={props.srcSet}
                                    alt=""
                                    role="presentation"
                                />
                            )}
                            imagePath={__image('expert_services/HubPage/support-banner-image')}
                            width={800}
                        />
                    </BannerImage>
                </BannerImageContainer>
            </Banner>
            {typeof window !== 'undefined' && !isChatAnywhereEnabled(locale) && (
                <ClassicChat
                    startChatElement="onlineBtn"
                    onlineElementIds={['online']}
                    loader="loader"
                    locale={locale}
                    tenant="vistaprint"
                    requestor="classicChatPackage"
                />
            )}
        </>
    );
}
